export default __webpack_public_path__ + "static/media/live-video.4fae1990.svg";